import { useEffect, useState } from "react";
import { api } from "../api.ts";
import { AvisoError, useAccion } from "./comun.tsx";

interface Fila { id: string; hc: number; nombres: string; apellidos: string; doc: string; telefono: string; es_prueba: boolean; creado: string }

/**
 * Configuración → «Pacientes de prueba» (administración). Un paciente de prueba se OCULTA: no sale en las listas ni en las búsquedas, no cuenta en
 * reportes ni comisiones y no recibe mensajes automáticos. No se borra nada y se puede quitar la marca cuando quieras.
 */
export function PacientesPrueba() {
  const [q, setQ] = useState("");
  const [filas, setFilas] = useState<Fila[] | null>(null);
  const [elegidos, setElegidos] = useState<Set<string>>(new Set());
  const [msg, setMsg] = useState("");
  const a = useAccion();

  const cargar = (texto: string) => api<{ pacientes: Fila[] }>("GET", `/api/pacientes-prueba${texto.trim() ? `?q=${encodeURIComponent(texto.trim())}` : ""}`).then((r) => setFilas(r.pacientes)).catch(a.setError);
  useEffect(() => { const t = setTimeout(() => { setElegidos(new Set()); cargar(q); }, q ? 250 : 0); return () => clearTimeout(t); }, [q]);

  const alternar = (id: string) => setElegidos((s) => { const n = new Set(s); if (n.has(id)) n.delete(id); else n.add(id); return n; });
  const marcados = (filas ?? []).filter((f) => f.es_prueba).length;
  const elegidosSinMarca = (filas ?? []).filter((f) => elegidos.has(f.id) && !f.es_prueba).length;
  const elegidosMarcados = (filas ?? []).filter((f) => elegidos.has(f.id) && f.es_prueba).length;

  async function cambiar(prueba: boolean) {
    const ids = (filas ?? []).filter((f) => elegidos.has(f.id) && f.es_prueba !== prueba).map((f) => f.id);
    if (!ids.length) return;
    if (prueba && !confirm(`¿Marcar ${ids.length} paciente${ids.length === 1 ? "" : "s"} como de prueba? Dejarán de salir en las listas y búsquedas, y no contarán en reportes, comisiones ni mensajes automáticos. No se borra nada.`)) return;
    const r = await a.correr(() => api<{ cambiados: number }>("POST", "/api/pacientes-prueba", { ids, prueba }));
    if (r) { setMsg(prueba ? `Listo: ${r.cambiados} paciente${r.cambiados === 1 ? "" : "s"} marcado${r.cambiados === 1 ? "" : "s"} como de prueba y oculto${r.cambiados === 1 ? "" : "s"}.` : `Listo: se quitó la marca a ${r.cambiados}.`); setElegidos(new Set()); await cargar(q); }
  }

  return (
    <div className="card" style={{ boxShadow: "none", display: "grid", gap: 10 }}>
      <h3 style={{ margin: 0 }}>Pacientes de prueba</h3>
      <p style={{ margin: 0 }}>
        Marca aquí a los pacientes que creaste solo para probar Donna. Un paciente de prueba <b>se oculta</b>: no sale en las listas ni en las búsquedas, no cuenta en los reportes ni en las comisiones y no recibe mensajes automáticos.
        <b> No se borra nada</b>: puedes quitar la marca cuando quieras. Para verlos de nuevo en el buscador del Inicio, marca «Incluir pacientes de prueba».
      </p>
      <label className="campo">Buscar paciente para marcarlo
        <input className="entrada" type="search" value={q} onChange={(e) => setQ(e.target.value)} placeholder="Nombre, cédula o número de historia" />
      </label>
      <AvisoError error={a.error} />
      {msg && <div className="aviso ok" role="status">{msg}</div>}
      {filas === null ? <p className="muted">Cargando…</p> : filas.length === 0 ? (
        <p className="muted">{q.trim() ? "Sin coincidencias." : "Todavía no hay pacientes de prueba. Busca arriba el nombre de los que quieras ocultar."}</p>
      ) : (
        <>
          <p className="muted" style={{ margin: 0 }}>{q.trim() ? `${filas.length} resultado${filas.length === 1 ? "" : "s"}` : `${marcados} paciente${marcados === 1 ? "" : "s"} de prueba`}.</p>
          <ul className="lista" style={{ margin: 0 }}>
            {filas.map((f) => (
              <li key={f.id} style={{ display: "flex", gap: 8, alignItems: "center", padding: "4px 0" }}>
                <input type="checkbox" checked={elegidos.has(f.id)} onChange={() => alternar(f.id)} aria-label={`Elegir a ${f.nombres} ${f.apellidos}`} />
                <span style={{ flex: 1 }}>
                  <b>{f.nombres} {f.apellidos}</b> <span className="muted mono">· HC {f.hc}{f.doc ? ` · ${f.doc}` : ""}</span>
                  {f.es_prueba && <span className="chip rojo" style={{ marginLeft: 6 }}>De prueba</span>}
                </span>
                <a className="btn chico" href={`#/paciente/${f.id}/ficha`} target="_blank" rel="noopener">Abrir</a>
              </li>
            ))}
          </ul>
          <div className="fila" style={{ flexWrap: "wrap", gap: 8 }}>
            <button className="btn pri" onClick={() => cambiar(true)} disabled={a.ocupado || elegidosSinMarca === 0}>Marcar como de prueba (ocultar){elegidosSinMarca ? ` · ${elegidosSinMarca}` : ""}</button>
            <button className="btn" onClick={() => cambiar(false)} disabled={a.ocupado || elegidosMarcados === 0}>Quitar la marca{elegidosMarcados ? ` · ${elegidosMarcados}` : ""}</button>
          </div>
        </>
      )}
    </div>
  );
}
